import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Plugins } from '@capacitor/core';
import '@capacitor-community/firebase-analytics';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

const { FirebaseAnalytics } = Plugins;

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {
    constructor(private platform: Platform, private auth: AuthService, private router: Router) {}

    public initializeWeb() {
        if (!this.isMobile()) {
            FirebaseAnalytics.initializeFirebase({
                apiKey: 'AIzaSyC-lFwsy_gVpE64viDtCCetiKasLj-8dKk',
                authDomain: 'groovycar-app.firebaseapp.com',
                databaseURL: 'https://groovycar-app.firebaseio.com',
                projectId: 'groovycar-app',
                storageBucket: 'groovycar-app.appspot.com',
                messagingSenderId: '732268713707',
                appId: '1:732268713707:web:951564459cd73a4e7050ae',
                measurementId: 'G-R3511QJCK2'
            });
        }
    }

    public setUserId() {
        FirebaseAnalytics.setUserId({
            userId: this.auth.currentAuth.user.uid
        });
    }

    public logEvent(name: string, params: any) {
        this.setScreenName();
        FirebaseAnalytics.logEvent({
            name,
            params: {
                userId: this.auth.currentAuth.user.uid,
                ...params
            }
        });
    }

    private setScreenName() {
        if (this.isMobile) {
            FirebaseAnalytics.setScreenName({
                screenName: this.router.url
            });
        }
    }

    private isMobile() {
        return this.platform.is('cordova') || this.platform.is('capacitor');
    }
}
